/**
 * Detects iOS and iPadOS. iPads (Safari and WKWebView) report a desktop "Macintosh" user
 * agent by default, so they're told apart from Macs by touch support.
 */
export function getIsIOS() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  const { userAgent, maxTouchPoints } = navigator;
  return (
    /iPhone|iPad|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1)
  );
}
